module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/is-pure.js
// module id = 18
// module chunks = 1